import { useBrandingThemeEpoch } from "./useBrandingThemeEpoch";
import { getBrandColors, isDarkMode } from "../styles/branding";

/**
 * Subscribe to theme / branding updates and return current palette + dark UI flag.
 * Use this instead of calling `getBrandColors()` / `isDarkMode()` alone so toggling
 * light/dark re-renders with fresh colors (fixes stale accent / primary).
 */
export function useBrandAppearance(): {
	colors: ReturnType<typeof getBrandColors>;
	isDark: boolean;
} {
	useBrandingThemeEpoch();
	return {
		colors: getBrandColors(),
		isDark: isDarkMode(),
	};
}
